import React from "react";

function VisionSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col lg:flex-row items-center lg:items-start gap-12">
        {/* Left Section (Image) */}
        <div className="lg:w-1/2 flex justify-center">
          <img
            src="https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwzNjUyOXwwfDF8c2VhcmNofDF8fGZ1dHVyZXxlbnwwfHx8fDE2ODM5MDI5NjA&ixlib=rb-1.2.1&q=80&w=1080"
            alt="Vision Illustration"
            className="rounded-lg shadow-md w-full max-h-48 object-cover"
          />
        </div>

        {/* Right Section (Text) */}
        <div className="lg:w-1/2 text-center lg:text-left">
          <h2 className="text-4xl font-extrabold text-primary mb-6">
            Our Vision
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            To create a better future by driving innovation and excellence
            across diverse industries, empowering communities, and fostering
            sustainable growth.
          </p>
          <p className="text-lg text-gray-600 mt-4 leading-relaxed">
            At Chiranthan Enterprises, we envision a world where ideas become
            impactful realities.
          </p>
        </div>
      </div>
    </section>
  );
}

export default VisionSection;
